// Storage (Object Storage) service gating — mirrors waap-service.ts. Object
// Storage is provisioned on the dedicated `elephant` provider (Wasabi): a
// first-time activation mints a per-customer Wasabi sub-account, and the backend
// stores its login as the service credential. A provisioned service opens the
// S3 console at /services/oss/:serviceId.
import type { AvailableService } from '@/api/services';

/** Provider codename that backs Object Storage (Wasabi — the Elephant provider). */
export const STORAGE_PROVIDER = 'elephant';

/** True when a provisioned service can open the S3 storage console. */
export function isStorageCapable(service: AvailableService): boolean {
  return service.provider?.name?.trim().toLowerCase() === STORAGE_PROVIDER;
}

/** Route to a service's S3 storage console. */
export function storageConsoleRoute(serviceId: string): string {
  return `/services/oss/${serviceId}`;
}

/** Card metadata for the Object Storage product (mirrors the catalog product). */
export const STORAGE_PRODUCT = {
  displayName: 'Object Storage',
  description:
    'S3-compatible object storage — buckets, access keys and versioning, backed by a per-account Wasabi tenant.',
  features: ['Buckets', 'Access Keys', 'Versioning'],
} as const;
